// Futuron Verified Firmware Registry (ESP8266, ESP32 & Arduino AVR Series)

export const FUTURON_FIRMWARES = [
  // --- ESP8266 / NODEMCU 0.9 & 1.0 SERIES ---
  {
    id: 'esp8266-serial-led',
    arch: 'esp8266',
    title: 'ESP8266 / NodeMCU Serial Command & LED Control (LED_ON / LED_OFF / STATUS)',
    description: 'Interactive serial responder controlling onboard LED (GPIO 2 / D4) with instant serial status replies.',
    version: 'v1.0.0',
    offset: '0x0000',
    tags: ['ESP8266', 'NodeMCU', 'Serial Command', 'LED Control'],
    downloadUrl: '/firmwares/esp8266_serial_led.bin',
    details: 'Listens for LED_ON, LED_OFF, STATUS, PING at 115200 baud and replies with LED state.'
  },
  {
    id: 'esp8266-blink',
    arch: 'esp8266',
    title: 'ESP8266 / NodeMCU LED Blink Diagnostic (Arduino-CLI Build)',
    description: 'Official compiled LED Blink binary for NodeMCU / ESP8266 (GPIO 2 / D4).',
    version: 'v1.0.0',
    offset: '0x0000',
    tags: ['ESP8266', 'NodeMCU', 'Blink', 'Arduino-CLI'],
    downloadUrl: '/firmwares/esp8266_blink.bin',
    details: 'Toggles GPIO2 LED every 500ms and prints serial status at 115200 baud.'
  },
  {
    id: 'nodemcu-webrelay',
    arch: 'esp8266',
    title: 'NodeMCU 0.9 / ESP8266 Web Switch Controller',
    description: 'Wi-Fi AP & Station Web Relay Controller sketch for NodeMCU 0.9 / ESP8266.',
    version: 'v1.5.0',
    offset: '0x0000',
    tags: ['NodeMCU 0.9', 'ESP8266', 'Web Server', 'Relay'],
    downloadUrl: '/firmwares/nodemcu_webrelay.bin',
    details: 'Pin D1 (GPIO5): Relay control, Pin D2 (GPIO4): Status LED.'
  },
  {
    id: 'nodemcu-telemetry',
    arch: 'esp8266',
    title: 'NodeMCU ESP8266 IoT Telemetry Node',
    description: 'Low-power Wi-Fi telemetry node publishing sensor data to Futuron Cloud.',
    version: 'v1.2.0',
    offset: '0x0000',
    tags: ['NodeMCU', 'ESP8266', 'MQTT', 'Telemetry'],
    downloadUrl: '/firmwares/nodemcu_telemetry.bin',
    details: 'Supports DeepSleep power management between telemetry updates.'
  },
  {
    id: 'micropython-esp8266',
    arch: 'esp8266',
    title: 'MicroPython ESP8266 Runtime (v1.22)',
    description: 'Official MicroPython 1.22 firmware for NodeMCU 0.9 & ESP8266 4MB chips.',
    version: 'v1.22.2',
    offset: '0x0000',
    tags: ['ESP8266', 'NodeMCU', 'MicroPython', 'REPL'],
    downloadUrl: '/firmwares/micropython_esp8266.bin',
    details: 'Standard 4MB Flash layout with WebREPL enabled.'
  },

  // --- ESP32 SERIES FIRMWARES ---
  {
    id: 'esp32-serial-led',
    arch: 'esp32',
    title: 'ESP32 Serial Command & LED Control (LED_ON / LED_OFF / STATUS)',
    description: 'Interactive serial responder controlling ESP32 onboard LED (GPIO 2) with instant serial status replies.',
    version: 'v1.0.0',
    offset: '0x10000',
    tags: ['ESP32', 'Serial Command', 'LED Control', '115200 Baud'],
    downloadUrl: '/firmwares/esp32_serial_led.bin',
    details: 'Listens for LED_ON, LED_OFF, STATUS, PING at 115200 baud and replies with LED state.'
  },
  {
    id: 'esp32-blink',
    arch: 'esp32',
    title: 'ESP32 LED Blink & Serial Diagnostic (Arduino-CLI Build)',
    description: 'Official compiled LED Blink binary for ESP32 boards (GPIO 2 / LED_BUILTIN).',
    version: 'v1.0.0',
    offset: '0x10000',
    tags: ['ESP32', 'Blink', 'Diagnostic', 'Arduino-CLI'],
    downloadUrl: '/firmwares/esp32_blink.bin',
    details: 'Toggles onboard GPIO2 LED every 1000ms and prints serial log at 115200 baud.'
  },
  {
    id: 'esp32-ultrasonic',
    arch: 'esp32',
    title: 'ESP32 HC-SR04 Ultrasonic Distance Sensor (Echo: 26, Trig: 27)',
    description: 'Real-time HC-SR04 ultrasonic distance measurement streaming over 115200 baud serial.',
    version: 'v1.0.0',
    offset: '0x10000',
    tags: ['ESP32', 'Ultrasonic', 'HC-SR04', 'GPIO 26/27'],
    downloadUrl: '/firmwares/esp32_ultrasonic.bin',
    details: 'Trigger Pin: GPIO 27, Echo Pin: GPIO 26. Measures distance in cm & inches every 500ms.'
  },
  {
    id: 'futuron-webrelay',
    arch: 'esp32',
    title: 'Futuron ESP32 WebRelay Controller',
    description: 'Smart Relay switch controller with 16x2 LCD display driver and built-in HTTP server.',
    version: 'v2.1.0',
    offset: '0x10000',
    tags: ['ESP32', 'Relay', 'LCD 16x2', 'Web Server'],
    downloadUrl: '/firmwares/futuron_webrelay.bin',
    details: 'Based on esp32serverv2 sketch. Pin 23: Relay, Pins 16-22: LCD.'
  },
  {
    id: 'futuron-iot-mqtt',
    arch: 'esp32',
    title: 'Futuron IoT Telemetry & MQTT Publisher',
    description: 'Real-time telemetry sensor node publishing data to Futuron Influx/MQTT cloud.',
    version: 'v1.4.2',
    offset: '0x10000',
    tags: ['ESP32', 'MQTT', 'InfluxDB', 'Telemetry'],
    downloadUrl: '/firmwares/futuron_iot_mqtt.bin',
    details: 'Auto-reconnects to Wi-Fi and streams telemetry packets every 5 seconds.'
  },
  {
    id: 'futuron-attendance',
    arch: 'esp32',
    title: 'Futuron Smart Attendance Scanner',
    description: 'Biometric & RFID attendance logger syncing with Futuron ERP database.',
    version: 'v3.0.1',
    offset: '0x10000',
    tags: ['ESP32', 'ERP', 'Attendance', 'RFID'],
    downloadUrl: '/firmwares/futuron_attendance.bin',
    details: 'Integrates directly with Selvams Attendance API endpoint.'
  },
  {
    id: 'micropython-v122',
    arch: 'esp32',
    title: 'MicroPython ESP32 Runtime (v1.22)',
    description: 'Official MicroPython firmware runtime for python script execution on ESP32.',
    version: 'v1.22.2',
    offset: '0x1000',
    tags: ['ESP32', 'MicroPython', 'Python', 'REPL'],
    downloadUrl: '/firmwares/micropython_esp32.bin',
    details: 'Includes WebREPL and asyncio standard library.'
  },

  // --- ARDUINO AVR SERIES (UNO, NANO) ---
  {
    id: 'arduino-serial-led',
    arch: 'avr',
    title: 'Arduino Uno/Nano Serial Command & LED Control (LED_ON / LED_OFF / STATUS)',
    description: 'Interactive serial responder controlling Pin 13 LED with formatted serial status replies.',
    version: 'v1.0.0',
    offset: '0x0000',
    tags: ['Arduino Uno', 'Arduino Nano', 'Serial Command', 'Pin 13 LED'],
    downloadUrl: '/firmwares/arduino_serial_led.hex',
    details: 'Listens for LED_ON, LED_OFF, STATUS, PING at 115200 baud and replies with LED state.'
  },
  {
    id: 'arduino-uno-blink',
    arch: 'avr',
    title: 'Arduino Uno Standard Blink (Pin 13 LED)',
    description: 'Classic Arduino Uno blink diagnostic binary toggling onboard Pin 13 LED every 1000ms.',
    version: 'v1.0.0',
    offset: '0x0000',
    tags: ['Arduino Uno', 'ATmega328P', 'Blink', 'Diagnostic'],
    downloadUrl: '/firmwares/arduino_uno_blink.hex',
    details: 'Compiled with AVR-GCC for ATmega328P at 16MHz clock.'
  },
  {
    id: 'arduino-nano-blink',
    arch: 'avr',
    title: 'Arduino Nano LED Blink (Arduino-CLI Build)',
    description: 'Official compiled Intel HEX binary for Arduino Nano ATmega328P (Pin 13).',
    version: 'v1.0.0',
    offset: '0x0000',
    tags: ['Arduino Nano', 'ATmega328P', 'Blink', 'Arduino-CLI'],
    downloadUrl: '/firmwares/arduino_nano_blink.hex',
    details: 'Toggles Pin 13 LED every 500ms and prints serial log at 57600 baud.'
  },
  {
    id: 'arduino-uno-telemetry',
    arch: 'avr',
    title: 'Arduino Uno Futuron Sensor Telemetry',
    description: 'Analog sensor logger streaming readings over Serial UART (115200 baud).',
    version: 'v1.0.0',
    offset: '0x0000',
    tags: ['Arduino Uno', 'ATmega328P', 'Telemetry', 'ADC'],
    downloadUrl: '/firmwares/arduino_uno_telemetry.hex',
    details: 'Reads A0-A5 analog pins and formats JSON telemetry frames.'
  },
  {
    id: 'arduino-nano-relay',
    arch: 'avr',
    title: 'Arduino Nano 4-Channel Relay Controller',
    description: 'Serial command controlled 4-relay channel driver for home automation.',
    version: 'v1.2.0',
    offset: '0x0000',
    tags: ['Arduino Nano', 'ATmega328P', 'Relay', 'Automation'],
    downloadUrl: '/firmwares/arduino_nano_relay.hex',
    details: 'Listens for RELAY1_ON, RELAY2_ON serial commands at 57600/115200 baud.'
  }
];

// Helper to create synthetic dummy ESP32 / ESP8266 binary
export function createSyntheticBinary(size = 65536, name = 'Futuron Firmware') {
  const buffer = new Uint8Array(size);
  buffer[0] = 0xE9;
  buffer[1] = 0x03;
  buffer[2] = 0x02;
  buffer[3] = 0x10;
  
  const headerStr = `FUTURON_FIRMWARE_HEADER: ${name} [BUILD_2026]`;
  for (let i = 0; i < headerStr.length; i++) {
    buffer[32 + i] = headerStr.charCodeAt(i);
  }

  for (let i = 256; i < size; i++) {
    buffer[i] = (i ^ 0xAA) & 0xFF;
  }

  return buffer;
}

// Helper to create synthetic Intel HEX string for Arduino testing
export function createSyntheticHex(name = 'Arduino Sketch') {
  let hexText = `:020000040000FA\n`;
  hexText += `:100000000C9434000C9451000C9451000C945100AC\n`;
  hexText += `:100010000C9451000C9451000C9451000C94510080\n`;
  hexText += `:100020000C9451000C9451000C9451000C94510070\n`;
  hexText += `:00000001FF\n`;
  return hexText;
}
